import multiguard from 'vue-router-multiguard';
import middleware from '@/router/middleware';

import Account from '@/views/account/Account';
import PersonalInfo from '@/views/account/PersonalInfo';
import CardInfo from '@/views/account/CardInfo';

export default {
  path: 'account',
  component: Account,
  children: [
    {
      path: 'personal-info',
      name: 'account-personal-info',
      component: PersonalInfo,
      alias: [ '/' ],
      meta: { title: 'Personal info' },
    },
    {
      path: 'card-info',
      name: 'account-card-info',
      component: CardInfo,
      meta: { title: 'Card info' },
    },
  ]
};
